import {
	createApp
} from 'vue'
import App from './App.vue'

/* 导入js文件,根据窗口调整html-font-size大小 */
import 'amfe-flexible'
import './assets/css/style.css'

import router from './router'


// 1. 引入你需要的组件
import {
	Button,
	NavBar,
	Swipe,
	SwipeItem,
	Search,
	Tabs,
	Tab,
	Rate,
	Divider
} from 'vant'
// 2. 引入组件样式
import 'vant/lib/index.css'

// 3. 注册你需要的组件
createApp(App).use(Button).use(NavBar).use(Swipe).use(SwipeItem).use(Search)
.use(Tabs).use(Tab).use(Rate).use(Divider).use(router).mount('#app')
